import { useQuery } from '@tanstack/react-query';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useCompanyContext } from '../../../../context/CompanyContext';
import ErrorMessage from '../../../../components/messages/ErrorMessage';
import { fecthCBMonthlyBilling } from '../../../../services/accounting/ContractBillingsService';
import MonthlyBillingTable from './MonthlyBillingTable';
import { useWatch } from 'react-hook-form';

const MonthlyBillingContainer = () => {
  const { selectedCompany } = useCompanyContext();
  const [contracts, year] = useWatch({
    name: ['contracts', 'year'],
  });

  const { data, isFetching, isError } = useQuery({
    queryKey: ['getCBMonthlyBilling', selectedCompany, contracts, year],
    queryFn: ({ signal }) => {
      return fecthCBMonthlyBilling(
        selectedCompany!.id,
        contracts,
        year ? new Date(year).getFullYear() : undefined,
        signal
      );
    },
    refetchOnWindowFocus: false,
    enabled: !!selectedCompany,
  });

  if (isFetching || !selectedCompany)
    return (
      <div className="text-center mx-auto mt-3">
        <ProgressSpinner />
      </div>
    );

  if (isError)
    return (
      <ErrorMessage
        content={'Failed to obtain data! Please try again later.'}
      />
    );

  return <MonthlyBillingTable billings={data.bills} months={data.months} />;
};
export default MonthlyBillingContainer;
